import { useState } from "react";
import PropTypes from "prop-types";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";


const ImportData = ({ onExpedienteParsed }) => {

    const [originalData, setOriginalData] = useState("");

    function parseExpedienteData(text) {
        const expedienteMatch = text.match(/Expediente:(.*?)\(/);
        const jurisdiccionMatch = text.match(/Jurisdicción:(.*?)\n/);
        const dependenciaMatch = text.match(/Dependencia:(.*?)\n/);
        const caratulaMatch = text.match(/Carátula:(.*)/);
        
        const expediente = expedienteMatch ? expedienteMatch[1].trim() : "";
        const jurisdiccion = jurisdiccionMatch ? jurisdiccionMatch[1].trim() : "";
        const dependencia = dependenciaMatch ? dependenciaMatch[1].trim() : "";
        const caratula = caratulaMatch ? caratulaMatch[1].trim() : "";
      
        // Extraer número, año y cuaderno del expediente (formato CNT 034414/2023/1)
        const expedienteDetailsMatch = expediente.match(/(\d{6})\/(\d{4})(?:\/(\d+))?/);
        const numero = expedienteDetailsMatch ? expedienteDetailsMatch[1] : "";
        const anio = expedienteDetailsMatch ? expedienteDetailsMatch[2] : "";
        const cuaderno = expedienteDetailsMatch ? expedienteDetailsMatch[3] : "";
      
        const obj = {
            numero,
            anio,
            cuaderno,
            jurisdiccion,
            dependencia,
            caratula,
        };
        onExpedienteParsed(obj);
      }

    return (
      // <Card>
      <MDBox position="relative" p={0}>
        <Accordion
          sx={{
            boxShadow: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? theme.palette.action.hover : "transparent !important",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <MDTypography display="block" variant="button" fontWeight="regular">
              Autocompletar datos
            </MDTypography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox>
              <MDInput
                fullWidth
                type="text"
                label="Coloque el texto con los datos del expediente"
                multiline
                value={originalData}
                rows={5}
                onChange={(event) => {
                  setOriginalData(event.target.value);
                }}
              />
            </MDBox>
          </AccordionDetails>
          <AccordionActions>
            <MDButton
              variant="gradient"
              color="success"
              onClick={() => parseExpedienteData(originalData)}
            >
              Cargar
            </MDButton>
          </AccordionActions>
        </Accordion>
      </MDBox>
    );
}

ImportData.propTypes = {
    onExpedienteParsed: PropTypes.func,
}

export default ImportData;